import './GameMat.css';
import GameMat from './GameMat';
export default GameMat;



// WEBPACK FOOTER //
// ./src/components/Game/components/GameMat/index.js